export default "__VITE_ASSET__6mCxqlbu__"